import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { StyledCard } from './index.styled';

type AppCardProps = {
  className?: string;
  title?: string | ReactNode;
  action?: ReactNode | string;
  actions?: ReactNode | string[] | React.ReactNode[];
  extra?: ReactNode | string;
  cover?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  heightFull?: boolean;
  lineTitleColor?: string;
  paddingHeader?: string;
  hasBorder?: boolean;

  [x: string]: any;
};

const AppCard: React.FC<AppCardProps> = ({
  title,
  extra,
  children,
  cover,
  className,
  actions,
  heightFull,
  lineTitleColor,
  paddingHeader,
  hasBorder = true,
  ...rest
}) => {
  return (
    <StyledCard
      hasBorder={hasBorder}
      className={clsx({ heightFull: heightFull }, className)}
      title={title}
      extra={extra ? extra : null}
      cover={cover}
      actions={actions as React.ReactNode[]}
      variant="outlined"
      lineTitleColor={lineTitleColor}
      paddingHeader={paddingHeader}
      {...rest}
    >
      {children}
    </StyledCard>
  );
};

export default AppCard;
